<div *ngIf="posicionCasilla.mostrar"
     id="dragDiv"
     #draggableDiv
     class="draggable resize overlay-borde-formulario"
     [ngStyle]="boxStyle">
      <svg #draggableIcon class="icon-draggable">
        <use #draggableHref xlink:href="#icon-draggable"></use>
       </svg>
</div>
